<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import Grid from '../Shared/Grid'
export default {
  name: 'CourseCertificates',
  props: ['courseId'],
  components: {
    Grid
  },
  mounted () {
    this.fetchCertificates()
  },
  data () {
    return {
      filterable: true,
      module: this.$route.meta.module,
      columnOptions: [
        { field: 'DATE_CREATED', name: 'DATE_CREATED', label: 'Upload Date', sortable: true, filterable: true, filter: '', type: 'date' }
      ]
    }
  },
  computed: {
    ...mapGetters('courses', [
      'certificateList'
    ])
  },
  methods: {
    ...mapActions('courses', [
      'fetchCertificates'
    ])
  }
}
</script>

<template>
  <div class="">
    <Grid 
      :data="certificateList"
      :columns="columnOptions"
      :onRequest="fetchCertificates"
      :filterable="filterable"/>
  </div>
</template>

<style>
</style>
